import { IStore } from '../../index';
import { INotificationsStore } from '../store';
import { TOmitFirstArg } from '../../Interfaces/OmitFirstArg';

type TPushErrorNotificationActionWithState = (
  state: IStore,
  text: string
) => { notifications: INotificationsStore };

export const pushError: TPushErrorNotificationActionWithState = (state, text) => {
  return {
    notifications: {
      ...state.notifications,
      message: {
        status: 'unread',
        text,
        type: 'error'
      },
      open: true
    }
  };
};

export type TPushNotificationErrorAction = TOmitFirstArg<TPushErrorNotificationActionWithState>;
